import { Accordion, AccordionProps } from '@material-ui/core'
import React from 'react'

const YumAccordion = (props: AccordionProps) => <Accordion elevation={0} {...props} />

export default YumAccordion
